export const PrivacyPolicy = () => {
    return (
        <section className="py-24 lg:py-32 bg-white">
            <div className="max-w-4xl mx-auto px-6 lg:px-12">
                <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-blue-700 mb-4 block font-display">
                    Legal
                </span>

                <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">
                    Privacy Policy
                </h1>

                <p className="mt-6 text-base lg:text-lg leading-relaxed text-slate-600">
                    This Privacy Policy describes how NextGen Systems collects,
                    uses, and safeguards information when you interact with our
                    website and services.
                </p>

                {/* Section */}
                <div className="mt-12 space-y-10">
                    <div>
                        <h2 className="text-xl font-semibold text-slate-900">
                            Information We Collect
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            We may collect information such as your name, email
                            address, and any details you voluntarily provide
                            through contact forms or communication channels.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold text-slate-900">
                            How We Use Information
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            Collected information is used to respond to inquiries,
                            improve our services, and provide a better user
                            experience. We do not sell or share your personal
                            data with third parties without consent.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold text-slate-900">
                            Data Security
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            We implement reasonable technical and organizational
                            measures to protect your information from unauthorized
                            access, disclosure, or misuse.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold text-slate-900">
                            Third-Party Services
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            Our website may use trusted third-party tools for
                            analytics, hosting, or communication. These services
                            operate under their own privacy policies.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold text-slate-900">
                            Changes to This Policy
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            We may update this Privacy Policy from time to time.
                            Updates will be reflected on this page.
                        </p>
                    </div>

                    <div className="border-t pt-8">
                        <h2 className="text-xl font-semibold text-slate-900">
                            Contact
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            For any privacy-related queries, please contact us
                            through the official communication channels listed
                            on this website.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};